<div class="col-sm-12" x-report-table="" x-config="config"></div>